import { EEntity } from '../../enums/entity.enum';
import { IParticipantEntityApi } from './participant-entity.interface';

export type DirectionTypeApi = 'Incoming' | 'Outgoing';

export interface IPhoneCallApi {
  '@odata.etag': string;
  activityid: string;
  activityadditionalparams: string;
  subscriptionid: string;
  actualdurationminutes: number;
  'actualdurationminutes@OData.Community.Display.V1.FormattedValue': string;
  createdon: string;
  'createdon@OData.Community.Display.V1.FormattedValue': string;
  directioncode: boolean;
  'directioncode@OData.Community.Display.V1.FormattedValue': DirectionTypeApi;
  phonenumber: string;
  senton: string;
  subject: string;
  _regardingobjectid_value: string;
  '_regardingobjectid_value@Microsoft.Dynamics.CRM.associatednavigationproperty': string;
  '_regardingobjectid_value@Microsoft.Dynamics.CRM.lookuplogicalname': EEntity;
  '_regardingobjectid_value@OData.Community.Display.V1.FormattedValue': string;
  solgari_durationformatted: string;
}

// 0 - Open (1 - Open), 1 - Completed (2 - Made, 3 - Received), 2 - Canceled (4 - Canceled)
export enum EStateCode {
  OPEN = 0,
  COMPLETED = 1,
  CANCELED = 2,
}

export enum EStatusCode {
  OPEN = 1,
  MADE = 2,
  CANCELED = 3,
  RECEIVED = 4,
}
//

// 750390001 - Dialer
// 750390000 - Regular
export enum ESolgariCallType {
  REGULAR = 750390000,
  DIALER = 750390001,
}

export interface IPhoneCallCreateEntityApi {
  phonenumber?: string;
  subject?: string;
  directioncode?: boolean;
  description?: string;
  actualdurationminutes?: number;
  phonecall_activity_parties?: IParticipantEntityApi[];
  activityadditionalparams?: string;
  solgari_durationformatted?: string;
  solgari_durationmilliseconds?: number;
  statecode?: EStateCode;
  statuscode?: EStatusCode;
  solgari_calltype?: ESolgariCallType;
}
